// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
// Slices
import { checkPeriodsSaveDisabled, fetchPeriods } from 'slices/period.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
//
import PeriodDrawer from './PeriodDrawer';
import PeriodsList from './PeriodsList';

const PaddingRulesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchPeriods());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(
        checkPeriodsSaveDisabled(isFirstDrawer)
      );
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('periods')}
      subtitle={getText('manage_periods')}
    >
      <div className="inner-content--wrapper">
        <PeriodsList confirmDiscardChanges={confirmDiscardChanges} />
        <PeriodDrawer confirmDiscardChanges={confirmDiscardChanges} />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default PaddingRulesPage;
